module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', {
    staticClass: "box grid grid-responsive week_notes_lesson_note",
    style: ({
      borderColor: _vm.event.color
    })
  }, [_c('div', {
    staticClass: "col-2-12 box-size"
  }, [_c('h3', {
    style: ({
      color: _vm.event.color
    })
  }, [_vm._v(_vm._s(_vm.event.title))]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "icon-clock"
  }), _vm._v(" " + _vm._s(_vm.$filters.timeStamp(_vm.event.start)) + " - " + _vm._s(_vm.$filters.timeStamp(_vm.event.end))), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-10-12"
  }, [(_vm.checkLengthWithoutHTML(_vm.event.learning_goal)) ? _c('div', {
    staticClass: "col-1-3"
  }, [_c('p', {
    style: ({
      color: _vm.event.color
    })
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('calendars.week_plan.learning_goal')))])]), _vm._v(" "), _c('div', {
    staticClass: "word-break",
    domProps: {
      "innerHTML": _vm._s(_vm.event.learning_goal)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.checkLengthWithoutHTML(_vm.event.description)) ? _c('div', {
    staticClass: "col-1-3"
  }, [_c('p', {
    style: ({
      color: _vm.event.color
    })
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('calendars.week_plan.content')) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "word-break",
    domProps: {
      "innerHTML": _vm._s(_vm.event.description)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.checkLengthWithoutHTML(_vm.event.notes_for_students)) ? _c('div', {
    staticClass: "col-1-3"
  }, [_c('p', {
    style: ({
      color: _vm.event.color
    })
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('calendars.week_plan.pupil_preparation')))])]), _vm._v(" "), _c('div', {
    staticClass: "word-break",
    domProps: {
      "innerHTML": _vm._s(_vm.event.notes_for_students)
    }
  })]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5738d0d9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/Mobile/WeekPlan/WeekPlanLesson.vue
// module id = 1931
// module chunks = 1